import { render, staticRenderFns } from "./TournamentNominations.vue?vue&type=template&id=40191965&lang=pug"
import script from "./TournamentNominations.vue?vue&type=script&lang=js"
export * from "./TournamentNominations.vue?vue&type=script&lang=js"
import style0 from "./TournamentNominations.vue?vue&type=style&index=0&id=40191965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports